import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { getEditorViewPluginKey } from './get-editor-view-plugin-key';

/**
 * Plugin used to provide access to the EditorView to the EditorPluginAI
 */
export var createGetEditorViewPlugin = function createGetEditorViewPlugin(_ref) {
  var setEditorView = _ref.setEditorView;
  return new SafePlugin({
    key: getEditorViewPluginKey,
    view: function view(editorView) {
      setEditorView(editorView);
      return {};
    }
  });
};